import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CarComponent } from './app-modules/car/car.component';
import { ChatWithFriendsComponent } from './app-modules/chat-with-friends/chat-with-friends.component';
import { ChatComponent } from './app-modules/chat/chat.component';
import { LoginComponent } from './app-modules/login/login.component';
import { LogoutComponent } from './app-modules/logout/logout.component';
import { RegisterComponent } from './app-modules/register/register.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AlertComponent } from './common-modules/alert/alert.component';
import { HeaderComponent } from './common-modules/header/header.component';
import { LoadingSpinnerComponent } from './common-modules/loading-spinner/loading-spinner.component';
import { AuthInterceptorService } from './service/http-interceptors/auth-interceptor-service';
import { HttpLoadingInterceptor } from './service/http-interceptors/http-loading-interceptor.service';
import { UserSetupComponent } from './app-modules/user-setup/user-setup.component';
import { HomeComponent } from './app-modules/home/home.component';
import { SidebarComponent } from './app-modules/sidebar/sidebar.component';
import { GetbetterActionButtonComponent } from './common-modules/getbetter-action-button/getbetter-action-button.component';
import { CountdownModule } from 'ngx-countdown';
import { ProfileComponent } from './app-modules/profile/profile.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ConfirmationPopupComponent } from './common-modules/confirmation-popup/confirmation-popup.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ConditionalLoadingSpinnerComponent } from './common-modules/loading-spinner-conditional/loading-spinner.component';
import { DisableMailNotificationsComponent } from './app-modules/disable-mail-notifications/disable-mail-notifications.component';
import { PrivacyPolicyComponent } from './app-modules/privacy-policy/privacy-policy.component';
import { ConversationStarterComponent } from './app-modules/conversation-starter/conversation-starter.component';
import { WelcomePageComponent } from './app-modules/welcome-page/welcome-page.component';
import { ChatFilterPipe } from './app-modules/chat/chat-filter.pipe';




@NgModule({
  declarations: [
    AppComponent,
    CarComponent,
    HeaderComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ChatComponent,
    ChatWithFriendsComponent,
    AlertComponent,
    LoadingSpinnerComponent,
    UserSetupComponent,
    HomeComponent,
    SidebarComponent,
    GetbetterActionButtonComponent,
    ProfileComponent,
    ConfirmationPopupComponent,
    ConditionalLoadingSpinnerComponent,
    DisableMailNotificationsComponent,
    PrivacyPolicyComponent,
    ConversationStarterComponent,
    WelcomePageComponent,
    ChatFilterPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    MDBBootstrapModule.forRoot(),
    ReactiveFormsModule,
    CountdownModule,
    PickerModule,
    ImageCropperModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true
    }
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
